var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningCircleWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 30,
    height: 30,
    viewBox: "0 0 172 172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86,22.93333c-34.76353,0 -63.06667,28.30313 -63.06667,63.06667c0,34.76353 28.30313,63.06667 63.06667,63.06667c34.76353,0 63.06667,-28.30313 63.06667,-63.06667c0,-34.76353 -28.30313,-63.06667 -63.06667,-63.06667zM86,34.4c28.56687,0 51.6,23.03313 51.6,51.6c0,28.56687 -23.03313,51.6 -51.6,51.6c-28.56687,0 -51.6,-23.03313 -51.6,-51.6c0,-28.56687 23.03313,-51.6 51.6,-51.6zM13.78464,45.79948c-2.29873,-0.06619 -4.41462,1.24743 -5.375,3.33698c-5.32025,11.15536 -8.40964,23.64089 -8.40964,36.86354c0,13.22265 3.08939,25.70818 8.40964,36.86354c0.83223,1.92662 2.65053,3.24464 4.74045,3.4362c2.08992,0.19155 4.11752,-0.77397 5.28612,-2.5172c1.1686,-1.74323 1.29146,-3.98562 0.32031,-5.84609c-4.63282,-9.71397 -7.28984,-20.49431 -7.28984,-31.93646c0,-11.44215 2.65703,-22.22249 7.28984,-31.93646c0.8615,-1.74977 0.77449,-3.81747 -0.23095,-5.48869c-1.00545,-1.67122 -2.79145,-2.71676 -4.74092,-2.77537zM158.0362,45.79948c-1.91728,0.11644 -3.64891,1.18516 -4.61255,2.84676c-0.96364,1.6616 -1.03127,3.69535 -0.18016,5.4173c4.63281,9.71397 7.28984,20.49431 7.28984,31.93646c0,11.44215 -2.65703,22.22249 -7.28984,31.93646c-0.97116,1.86047 -0.84831,4.10287 0.32029,5.84611c1.1686,1.74324 3.1962,2.70877 5.28613,2.51721c2.08993,-0.19156 3.90823,-1.5096 4.74045,-3.43623c5.32025,-11.15537 8.40964,-23.64089 8.40964,-36.86354c0,-13.22265 -3.08938,-25.70818 -8.40964,-36.86354c-0.98523,-2.15204 -3.1915,-3.47759 -5.55417,-3.33698zM79.44922,57.33333l1.0862,34.4h10.91797l1.0862,-34.4zM86.02239,100.07578c-5.07973,0 -8.10729,2.7021 -8.10729,7.33464c0,4.54653 3.02756,7.25625 8.10729,7.25625c5.0396,0 8.0737,-2.70972 8.0737,-7.25625c0,-4.63253 -3.0341,-7.33464 -8.0737,-7.33464z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircleWhite);
export default __webpack_public_path__ + "static/media/warning-circle-white.bab35f9e155acd97e9c23228eb46c931.svg";
export { ForwardRef as ReactComponent };